import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ContractDetailPage from "@/pages/admin/ContractDetailPage";

export const Route = createFileRoute("/_admin/admin/contracts/$id")({
  head: () => pageHead("Admin · Contracts", "AKIVA admin · contracts portal.", "/admin/contracts/$id", true),
  component: ContractDetailPage,
});
